export default __webpack_public_path__ + "static/media/027-mail.cb824eee.svg";